import React from 'react';
import CheckIcon from 'svg/CheckIcon';
import classNames from 'styles/utils/classNames';
import { OnboardingStepEnum } from '../../props';

interface Step {
  step: OnboardingStepEnum;
  stepTitle: string;
}

interface StepperProps {
  steps: Step[];
  currentStep: OnboardingStepEnum;
  className?: string;
}

const Stepper: React.FC<StepperProps> = ({ steps, currentStep, className = '' }) => {
  // Get the current step index
  const currentStepIndex = steps.findIndex((step) => step.step === currentStep);

  return (
    <div className={`mx-auto flex w-full max-w-[62rem] flex-col items-center ${className}`}>
      <div className="relative flex w-full items-center justify-between">
        <div className="absolute top-4 h-0.5 w-full bg-color-border-input-darkmode max-md:top-[9px]" />
        {steps.map((step, idx) => {
          const isActive = step.step === currentStep;
          const isCompleted = idx < currentStepIndex;
          return (
            <React.Fragment key={step.step}>
              <div className="relative  flex flex-col items-center">
                <div
                  className={classNames(
                    'absolute bottom-0 top-0 h-full w-1/2 bg-color-bg-darkmode-primary',
                    idx === 0 ? 'left-0' : idx === steps.length - 1 ? 'right-0' : 'hidden',
                  )}
                />
                <div className="relative z-10 flex items-center justify-center">
                  {isCompleted ? (
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-color-brand-primary max-md:h-5 max-md:w-5">
                      <CheckIcon className="h-7 w-7 text-color-text-lightmode-primary max-md:h-5 max-md:w-5" />
                    </div>
                  ) : isActive ? (
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-color-brand-primary shadow-[0px_0px_0px_4px_rgba(255,92,51,0.40)]  max-md:h-5 max-md:w-5">
                      <span className="block h-2.5 w-2.5 rounded-full bg-black max-md:h-1.5 max-md:w-1.5" />
                    </span>
                  ) : (
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-color-border-input-darkmode max-md:h-5 max-md:w-5">
                      <span className="block h-2.5 w-2.5 rounded-full bg-black max-md:h-1.5 max-md:w-1.5" />
                    </span>
                  )}
                </div>
                <span
                  className={`max-md:typography-product-chips-filters z-10 mt-3 text-center ${
                    isActive
                      ? 'text-color-text-lightmode-invert'
                      : 'text-color-text-darkmode-tertiary'
                  }`}
                >
                  {step.stepTitle}
                </span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Stepper;
